import React from 'react'
import injectSheet from 'react-jss'
import styles from './bulk-actions.styles'
import { ActionButton } from 'pobble-components/dist/bulk-action'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import TrashIcon from 'react-icons/lib/fa/trash-o'

const BulkActions = ({ classes, onDelete }) => (
  <ActionButton>
    {({ Menu, MenuItem, IconHolder, closePopover, bulkSelectedList }) => (
      <Menu>
        <MenuItem
          className={classes.delete}
          onClick={() => {
            closePopover()
            openConfirmationDialog({
              bodyText: `Are you sure you want to delete ${
                bulkSelectedList.length
              } moderation files?`,
              confirmText: `Delete moderation files`,
              action: () => onDelete(bulkSelectedList)
            })
          }}>
          <IconHolder>
            <TrashIcon />
          </IconHolder>
          Delete files
        </MenuItem>
      </Menu>
    )}
  </ActionButton>
)

export default injectSheet(styles)(BulkActions)
